import React from 'react';
import cn from 'clsx';

import Button, { ButtonGroup } from '../../library/button/button';

import styles from './confirmation.scss';

interface ConfirmationProps {
  confirmLabel?: string;
  declineLabel?: string;
  handleConfirm: () => void;
  handleDecline: () => void;
  hasOverlay?: boolean;
  layout?: 'horizontal' | 'vertical';
  showSpinner?: boolean;
}

function Confirmation(props: ConfirmationProps) {
  const {
    confirmLabel = 'Yes, Delete ',
    declineLabel = 'No, Keep',
    handleConfirm,
    handleDecline,
    hasOverlay = false,
    layout = 'horizontal',
    showSpinner = false
  } = props;

  return (
    <div
      className={cn(
        hasOverlay ? styles['confirmation-overlay'] : '',
        'confirmation'
      )}
    >
      <div className="confirmation__button-group">
        <ButtonGroup layout={layout}>
          <Button isPrimary onClick={handleConfirm} showSpinner={showSpinner}>
            {confirmLabel}
          </Button>
          <Button isSecondary onClick={handleDecline}>
            {declineLabel}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
}

export default Confirmation;
